/**
 * Left panel content for the register selection page
 * Displays the logo and a dashboard preview image
 */
const RegisterSelectionLeftPanel = () => {
  return (
    <div className="flex flex-col h-full">
      {/* Logo Section */}
      <div className="flex items-center gap-3 mb-8">
        <img src="/ctb_logo_1.png" alt="Capture The Bug" className="h-12 w-auto md:h-14" />
        <span className="sr-only">Capture The Bug</span>
      </div>

      {/* Dashboard Preview Image - Centered */}
      <div className="flex-1 flex items-center justify-center">
        <img
          src="/register-pic.webp"
          alt="Dashboard Preview"
          className="w-full max-w-sm object-contain rounded-lg shadow-lg"
        />
      </div>
    </div>
  );
};

export default RegisterSelectionLeftPanel;

